import React, { memo } from 'react';
import DialogComponent from '../Dialog/DialogComponent';
import { Trans, useTranslation } from 'react-i18next';

const ErrorMessage = memo(({ t, i18nKey, tParams, open, className = '', handleClose, message = '', closeText }) => {
  const standardMessageComponents = {
    centageSupportEmail: <a href="mailto:support@centage.com">support@centage.com</a>,
  };
  const { t: tError } = useTranslation(['error', 'common']);
  const finalMessage = !!t ? (
    //...translation key should be used
    !!tParams ? (
      //...use provided tParams instead of the global standard components (do not mix it)
      <Trans t={t} i18nKey={i18nKey}>
        {tParams}
      </Trans>
    ) : (
      //...use i18n translation with standard parameters
      <Trans t={t} i18nKey={i18nKey} components={standardMessageComponents} />
    )
  ) : (
    //...direct message should be used
    <Trans defaults={message} components={standardMessageComponents} />
  );
  return (
    <DialogComponent open={open} className={`${className} react-dialog-error`} handleClose={handleClose}>
      <div className="react-dialog-error-content">{finalMessage}</div>
      <div className="modal-button-footer">
        <button className="btn btn-sm btn-primary btn-confirm" autoFocus onClick={handleClose}>
          {closeText ? closeText : tError('common:BUTTON_OK')}
        </button>
      </div>
    </DialogComponent>
  );
});

export default ErrorMessage;